// custom typefaces
import 'typeface-montserrat';
import 'typeface-merriweather';
import 'prismjs/themes/prism-okaidia.css';
import 'firacode/distr/fira_code.css';
import 'react-typist/dist/Typist.css';
import './src/styles/main.css';
